function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 32.75C7.52513 32.75 0.25 25.4749 0.25 16.5C0.25 7.52513 7.52513 0.25 16.5 0.25C25.4749 0.25 32.75 7.52513 32.75 16.5C32.75 25.4749 25.4749 32.75 16.5 32.75ZM16.5 29.5C19.9478 29.5 23.2544 28.1304 25.6924 25.6924C28.1304 23.2544 29.5 19.9478 29.5 16.5C29.5 13.0522 28.1304 9.74558 25.6924 7.30761C23.2544 4.86964 19.9478 3.5 16.5 3.5C13.0522 3.5 9.74558 4.86964 7.30761 7.30761C4.86964 9.74558 3.5 13.0522 3.5 16.5C3.5 19.9478 4.86964 23.2544 7.30761 25.6924C9.74558 28.1304 13.0522 29.5 16.5 29.5ZM14.875 21.375H18.125V24.625H14.875V21.375ZM14.875 8.375H18.125V18.125H14.875V8.375Z"
});

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "#F15D2E",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.2c40c49c.svg";
export { ForwardRef as ReactComponent };